import ApiBase from '@/api/base';

export default {
  rlsCheck(args) {
    return ApiBase.get(`/user/rls_check`, args);
  },
};
